
import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from "react-redux";

import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';

import ProInputText from "../../components/common/ProInputText";
import ProDropDown from "../../components/common/ProDropDown";
import ProCheckBox from "../../components/common/ProCheckbox";
import ProTextArea from "../../components/common/ProTextArea";

import { GetWaitlists, AddWaitlist } from '../../redux/actions/SettingAction'
import { SuccessToast, ErrorToast } from '../../redux/actions/ToasterAction';
import { ShowSpinner, HideSpinner } from '../../redux/actions/SpinnerAction';

import { useFormik } from "formik";
import { useDialogService } from '../../hooks/useDialogService';
import {useLocationServices} from "../../hooks/useLocationServices";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import useRolePermissionServices from '../../hooks/useRolePermissionServices';

import { Severity } from '../../constants/ProConstants';
import {duplicateCheck} from "../../utilities/Helper"
import _ from 'lodash'

const initialState = {
    name: '',
    description: '',
    isActive: true,
    program: null,
    location: null,
};
const ManageWaitlist = ({ globalFilter, toggleSideBar, addNew }) => {   
    const [formData, setFormData] = useState(initialState)
    const [headingText, setHeadingText] = useState('Add New Waitlist');
    const {actions:{ShowDialog}} = useDialogService();
    const {programs, locations} = useLocationServices();
    const { height } = useWindowDimensions();
    const {data:{WaitlistRoles}} = useRolePermissionServices()
    
    let items = [
        { label: 'Edit', icon: 'fas fa-edit', command: (e) => { onEdit(e) } },
    ];

    const allWaitlist = useSelector((state) => {
        return state.setting.allWaitlist;
    })

    const dispatch = useDispatch();
    const GetAllWaitlist = useCallback(async (node, data) => {
        dispatch(ShowSpinner());
        try {
            var action = await GetWaitlists();
            dispatch(action);
            dispatch(HideSpinner());
        }
        catch(err) {
            dispatch(HideSpinner());
        }

    }, [dispatch])


    useEffect(() => {
        GetAllWaitlist();
    }, [GetAllWaitlist]);

    const onEdit = (e) => {
        setFormData(e.item.data)
        setHeadingText('Edit Waitlist');
        addNew()
    }

    const toggleMenu = (menu, event, rowData) => {
        items.forEach((menuItem) => {
            menuItem.data = rowData;
        });
        menu && menu.toggle(event);
    }

    const actionBodyTemplate = (rowData) => {
        if(WaitlistRoles.canModifyWaitlist)
        {
            return (               
                <React.Fragment>
                    <i className="pi pi-ellipsis-h" onClick={(event) => toggleMenu(rowData.menuRef, event, rowData)}></i>
                    <Menu model={items} popup ref={(el) => rowData.menuRef = el} />
                </React.Fragment>
            );
        }else{
            return <></>
        }
    }

    const formik = useFormik({
        initialValues: formData,
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};
            if (_.isEmpty(_.trim(data.name))) {
                errors.name = `Name is required.`;
            }
            if (!_.isEmpty(data.name) && data.name.length > 120) {
                errors.name = "Max 120 characters allowed";
            }
            if (!_.isEmpty(data.name) && duplicateCheck(allWaitlist,'name', data)) {
                errors.name = "Waitlist name already exists!";
            }
            if (!_.isEmpty(data.description) && data.description.length > 500) {
                errors.description = "Max 500 characters allowed";
            }
            return errors;
        },
        onSubmit: (data) => {
            handleSubmit(data);
        },
    });
    const resetFormik = useCallback(() => {
        setFormData(initialState)
        formik.resetForm()
        addNew();
        setHeadingText('Add New Waitlist');
    },[formik, addNew])
    const handleSubmit = useCallback(async (data) => {
        try {
            data = _.omit(data, ['menuRef']);
            data.name =_.trim(data.name);
            dispatch(ShowSpinner());
            var action = await AddWaitlist(data);
            dispatch(action);
            dispatch(HideSpinner());
            if(data.id){
                dispatch(SuccessToast('Success', 'Updated Successfully!'));
            } else {
                dispatch(SuccessToast('Success', 'Saved Successfully!'));
            }
            GetAllWaitlist();
        }
        catch(err) {
            dispatch(HideSpinner());
            dispatch(ErrorToast('Error', _.get(err, 'response.data.message')));
        }
        resetFormik()
    }, [dispatch, GetAllWaitlist, resetFormik])

    const handleActiveChanged = async (checked)=>{
        if(!checked){
            await ShowDialog(`Inactivate ${formik.values.name} Waitlist?`, null,null, "Yes, Inactivate", "Cancel", Severity.Danger,
                        ()=>{
                            formik.setValues({ ...formik.values, isActive: checked, isDefault: !checked ? false:formik.values.isDefault})
                        },
                        ()=>{
                            formik.setValues({ ...formik.values, isActive: true, isDefault: formik.values.isDefault})
                        })
        }else{           
            formik.setValues({ ...formik.values, isActive: checked, isDefault: !checked ? false:formik.values.isDefault})
        }
    }
    return (<div>
        <Sidebar dismissable={false} modal={false}
            visible={toggleSideBar} position="right"
            style={{ width: '30em', zIndex: 1103 }} onHide={() => resetFormik()} icons={() => (
                <h6 className="p-sidebar-close"
                    style={{
                        fontWeight: '700', fontSize: '20px', width: '100%',
                        margin: 'auto'
                    }}>{headingText}</h6>
            )}>
            <form onSubmit={formik.handleSubmit}>
                <ProInputText
                    headerText="Name"
                    id="name"
                    labelText="Name"
                    formik={formik}
                    name="name"
                    error="name"
                    required
                    value={formik.values.name}
                    onChange={(e) => {
                        formik.setValues({ ...formik.values, name: e.target.value });
                    }}
                />
                <ProTextArea
                    rows={7} cols={30}
                    headerText="Description"
                    id="description"
                    labelText="Description"
                    value={formik.values.description}
                    formik={formik}
                    name="description"
                    error="description"
                    onChange={(e) => {
                        formik.setValues({ ...formik.values, description: e.target.value });
                    }}
                    showCounter
                />
                
                {/* <ProDropDown
                     id="program"
                     value={formik.values.program}
                     style={{ width: "100%", marginBottom: "2px" }}
                     onChange={(e) => {                        
                         console.log(e.target.value)
                        formik.setValues({ ...formik.values, program: e.target.value });
                    }}
                     options={programs.map(a => {
                         return _.pick(a, ["id", "name"])
                     })}
                     optionLabel="name"
                     placeholder="Program"
                 />
                <ProDropDown
                     id="location"
                     value={formik.values.location}
                     style={{ width: "100%", marginBottom: "2px" }}
                     onChange={(e) => {
                        formik.setValues({ ...formik.values, location: e.target.value });
                    }}
                    options={locations.map(a => {
                        return _.pick(a, ["id", "name"])
                    })}
                     optionLabel="name"
                     placeholder="Location"
                 /> */}
                <ProCheckBox
                    id="isActive"
                    name="isActive"
                    labelText="Active"
                    checked={formik.values.isActive}
                    onChange={(e) => handleActiveChanged(e.target.checked)}
                />
                <div className="p-d-flex p-jc-start" style={{ marginTop: "25px" }}>
                    <Button label="Cancel" type="button" className="p-button-text" onClick={() => { resetFormik() }} style={{ color: "#34436d" }} />
                    <Button label="Save" type="submit" style={{ backgroundColor: "#34436d" }} />
                </div>
            </form>
        </Sidebar>

        <DataTable value={allWaitlist}
            dataKey="id"
            breakpoint="960px"
            header="Waitlists"
            globalFilter={globalFilter}
            responsiveLayout="stack"
            scrollable scrollHeight={`${height-225}px`}>         
            <Column field="name" header="Name" sortable></Column>
            <Column field="description" header="Description" sortable style={{ width: '30%' }}></Column>
            <Column field="program.name" header="Program" sortable></Column>
            <Column field="location.name" header="Location" sortable></Column>
            <Column field="isActive"
                body={(rowData) => {
                    return <span className={`table-badge status-${rowData.isActive ? 'active' : 'inactive'}`}>{rowData.isActive ? 'Active' : 'Inactive'}</span>;
                }}
                header="Active" sortable></Column>
            <Column body={actionBodyTemplate} style={{ width: '5%' }}></Column>
        </DataTable>
    </div>)

}

export default ManageWaitlist;